import { TClaimedCharacter } from '../../../types/characterTypes';
import { TAction } from './types/action';

// Action Types
export const SET_USER_PROFILE_PARAMS = 'SET_USER_PROFILE_PARAMS';
export const SET_USER_SOCIAL_PARAMS = 'SET_USER_SOCIAL_PARAMS';
export const SET_USER_NOTIFICATION_PARAMS = 'SET_USER_NOTIFICATION_PARAMS';
export const SET_USER_BATTLENET_PARAMS = 'SET_USER_BATTLENET_PARAMS';
export const SET_USER_PATREON_PARAMS = 'SET_USER_PATREON_PARAMS';
export const SET_USER_XSOLLA_PARAMS = 'SET_USER_XSOLLA_PARAMS';
export const SET_USER_SUBSCRIPTIONS_PARAMS = 'SET_USER_SUBSCRIPTIONS_PARAMS';
export const SET_USER_PREMIUM_PARAMS = 'SET_USER_PREMIUM_PARAMS';
export const SET_USER_PREMIUM_ERROR = 'SET_USER_PREMIUM_ERROR';
export const SET_BLOCK_LIST = 'SET_BLOCK_LIST';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const SET_CHARACTER_CUSTOMIZATION_PARAMS = 'SET_CHARACTER_CUSTOMIZATION_PARAMS';
export const UPDATE_AUTH_CLAIMED_CHARACTERS = 'UPDATE_AUTH_CLAIMED_CHARACTERS';
export const DELETE_AUTH_CLAIMED_CHARACTER = 'DELETE_AUTH_CLAIMED_CHARACTER';
export const DELETE_AUTH_CLAIMED_CHARACTERS = 'DELETE_AUTH_CLAIMED_CHARACTERS';
export const SET_IS_CHINA_USER = 'SET_IS_CHINA_USER';
export const SET_CHARACTER_PRIVACY_PARAMS = 'SET_CHARACTER_PRIVACY_PARAMS';
export const SET_GROUP_CUSTOMIZATION_PARAMS = 'SET_GROUP_CUSTOMIZATION_PARAMS';
export const SET_GROUP_PRIVACY_CUSTOMIZATION_PARAMS = 'SET_GROUP_PRIVACY_CUSTOMIZATION_PARAMS';
export const SET_GROUP_CLIENT_USAGE_DATA = 'SET_GROUP_CLIENT_USAGE_DATA';
export const SET_GROUP_ROLE_PARAMS = 'SET_GROUP_ROLE_PARAMS';
export const ADD_ROLE_TO_GROUP_RANK = 'ADD_ROLE_TO_GROUP_RANK';
export const REMOVE_ROLE_FROM_GROUP_RANK = 'REMOVE_ROLE_FROM_GROUP_RANK';
export const ADD_PENDING_ROLE_PARAMS = 'ADD_PENDING_ROLE_PARAMS';
export const RELOAD = 'RELOAD';

// Action Creator
const UserSettingsActionCreator = {
  setBlockList(params: any): TAction<any> {
    return {
      type: SET_BLOCK_LIST,
      payload: params
    };
  },

  setCharacterCustomizationParams(params: any): TAction<any> {
    return {
      type: SET_CHARACTER_CUSTOMIZATION_PARAMS,
      payload: params
    };
  },

  setCharacterPrivacyParams(params: any): TAction<string> {
    return {
      type: SET_CHARACTER_PRIVACY_PARAMS,
      payload: params
    };
  },

  setGroupCustomizationParams(params: any): TAction<any> {
    return {
      type: SET_GROUP_CUSTOMIZATION_PARAMS,
      payload: params
    };
  },

  setGroupPrivacyCustomizationsParams(params: any): TAction<any> {
    return {
      type: SET_GROUP_PRIVACY_CUSTOMIZATION_PARAMS,
      payload: params
    };
  },

  setGroupClientUsageData(params: any): TAction<any> {
    return {
      type: SET_GROUP_CLIENT_USAGE_DATA,
      payload: params
    };
  },

  setGroupRoleParams(params: any): TAction<any> {
    return {
      type: SET_GROUP_ROLE_PARAMS,
      payload: params
    };
  },

  addRoleToGroupRank(params: any): TAction<any> {
    return {
      type: ADD_ROLE_TO_GROUP_RANK,
      payload: params
    };
  },

  removeRoleFromGroupRank(params: any): TAction<any> {
    return {
      type: REMOVE_ROLE_FROM_GROUP_RANK,
      payload: params
    };
  },

  addPendingRoleParams(params: any): TAction<any> {
    return {
      type: ADD_PENDING_ROLE_PARAMS,
      payload: params
    };
  },

  setUserProfileParams(params: any): TAction<string> {
    return {
      type: SET_USER_PROFILE_PARAMS,
      payload: params
    };
  },

  setUserSocialParams(params: any): TAction<string> {
    return {
      type: SET_USER_SOCIAL_PARAMS,
      payload: params
    };
  },

  setUserNotificationParams(params: any): TAction<string> {
    return {
      type: SET_USER_NOTIFICATION_PARAMS,
      payload: params
    };
  },

  setUserBattleNetParams(params: any): TAction<string> {
    return {
      type: SET_USER_BATTLENET_PARAMS,
      payload: params
    };
  },

  setUserPatreonParams(params: any): TAction<string> {
    return {
      type: SET_USER_PATREON_PARAMS,
      payload: params
    };
  },

  setUserXsollaParams(params: any): TAction<string> {
    return {
      type: SET_USER_XSOLLA_PARAMS,
      payload: params
    };
  },

  setUserSubscriptionsParams(params: any): TAction<string> {
    return {
      type: SET_USER_SUBSCRIPTIONS_PARAMS,
      payload: params
    };
  },

  setUserPremiumParams(params: any): TAction<string> {
    return {
      type: SET_USER_PREMIUM_PARAMS,
      payload: params
    };
  },

  setUserPremiumError(error: any): TAction<any> {
    return {
      type: SET_USER_PREMIUM_ERROR,
      payload: error
    };
  },

  showLoadingSpinner(show: boolean): TAction<boolean> {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  },

  reload(): TAction<void> {
    return {
      type: RELOAD,
      payload: undefined
    };
  },

  updateAuthClaimedCharacters(params: TClaimedCharacter[]): TAction<TClaimedCharacter[]> {
    return {
      type: UPDATE_AUTH_CLAIMED_CHARACTERS,
      payload: params
    };
  },

  deleteAuthClaimedCharacter(characterId: number): TAction<number> {
    return {
      type: DELETE_AUTH_CLAIMED_CHARACTER,
      payload: characterId
    };
  },

  deleteAuthClaimedCharacters(): TAction<void> {
    return {
      type: DELETE_AUTH_CLAIMED_CHARACTERS,
      payload: undefined
    };
  },

  setIsChinaUser(isChinaUser: boolean): TAction<boolean> {
    return {
      type: SET_IS_CHINA_USER,
      payload: isChinaUser
    };
  }
};

// utils
export const updateAuthClaimedCharacters = (state: any, action: TAction<any>) => {
  if (!state.claimedCharacters) {
    return state;
  }

  if (!action.payload.character) {
    return state;
  }

  if (!action.payload.customizations) {
    return state;
  }

  const currentClaimedCharacters = state.claimedCharacters || [];

  const updatedCharacterId = action.payload.character?.id;
  const updatedIsMainField = action.payload.customizations?.is_main_character;

  const updatedClaimedCharacters = currentClaimedCharacters.map((character: any) => {
    if (character.id === updatedCharacterId) {
      return {
        ...character,
        is_main_character: updatedIsMainField
      };
    }

    if (updatedIsMainField) {
      return {
        ...character,
        is_main_character: false
      };
    }

    return character;
  });

  return {
    ...state,
    claimedCharacters: updatedClaimedCharacters
  };
};

export default UserSettingsActionCreator;
